export default __webpack_public_path__ + "static/media/11-small.5c61c575.png";